import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../utils/motion';
import { noetivraAvailabilityLabel } from '../data/siteContent';
const modules = [{
  name: 'CJI',
  desc: 'Structured reasoning and judgment assessment.'
}, {
  name: 'NCJI Youth',
  desc: 'Developmental support for early education.'
}, {
  name: 'NCJI Pathways',
  desc: 'Workforce readiness and opportunity alignment.'
}, {
  name: 'NCJI Civic',
  desc: 'Community resilience and manipulation resistance.'
}, {
  name: 'NCJI Service',
  desc: 'Integrity and systems reasoning for the public sector.'
}, {
  name: 'NCJI Executive',
  desc: 'Crisis reasoning and governance readiness.'
}, {
  name: 'NCJI Atlas',
  desc: 'Aggregate capability mapping for institutions.'
}];
export function ProductEcosystem() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto border-t border-line" data-id="element-1847" data-mp="2wmatohpvr0di">
      <div className="mb-12" data-id="element-1848" data-mp="30murzom6wa18">
        <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em] mb-4 block" data-id="element-1849" data-mp="30qa6ap81hf1l">
          Assessment &amp; Development Modules
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-1850" data-mp="yofp0p493gr7">
          Within the Human Capability Framework
        </h2>
        <p className="mt-4 text-lg text-ink-muted leading-relaxed max-w-3xl" data-id="element-1851" data-mp="pnhwb2z9ivnx">
          The framework combines assessment methods, development pathways, and
          supporting services. These are proposed modules within CJI and NCJI. Each would
          require validation for its intended use before consequential
          application.
        </p>
      </div>

      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-1852" data-mp="ayldqbzky092">
        {modules.map(module => <li key={module.name} className="bg-surface-card p-6 rounded-lg border border-line flex flex-col h-full" data-id="element-1853" data-mp="1xniai37j123">
            <h3 className="text-lg font-heading font-bold text-navy mb-2" data-id="element-1854" data-mp="3t3eximfg4ta4">{module.name}</h3>
            <p className="text-sm text-ink-muted" data-id="element-1855" data-mp="3jgko4lx5b1nq">{module.desc}</p>
          </li>)}
      </ul>

      <motion.div {...fadeUp} className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 border-t border-line pt-12" data-id="element-1856" data-mp="3nifp1pb5zd0z">
        <div className="lg:col-span-5" data-id="element-1857" data-mp="39jzji1p1fskf">
          <p className="text-sm font-medium text-teal mb-2" data-id="element-1858" data-mp="3egzp6bhz6tb0">Noetivra · {noetivraAvailabilityLabel}</p>
          <h3 className="font-heading font-bold text-2xl lg:text-3xl text-ink-dark leading-tight" data-id="element-1859" data-mp="61offn7xneg4">
            Use the framework through Noetivra
          </h3>
        </div>
        <div className="lg:col-span-7" data-id="element-1860" data-mp="b2c3c00v7f64">
          <p className="text-lg text-ink-dark leading-relaxed mb-4" data-id="element-1861" data-mp="3shsnz8fb8ajx">
            The framework’s methods inform Noetivra’s Capability module, which
            the Education, Workforce, Leadership and Community solutions use. In
            their demos you can complete a task, receive criterion-based review,
            follow a development activity and compare reassessment evidence.
          </p>
          <p className="text-ink-muted leading-relaxed mb-6" data-id="element-1862" data-mp="2egmf95n5wcsg">
            SKP maintains the approved definitions, research and versioned
            knowledge supporting that work. Demo criteria are illustrative task
            rubrics, not validated CJI or NCJI instruments.
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-2" data-id="element-1863" data-mp="2j7mfajrkvaz6">
            <a href="/noetivra#human-capability-edition" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1864" data-mp="2ja8u94gsssrf">
              The Capability module
              <ArrowRight size={16} aria-hidden="true" data-id="element-1865" data-mp="24kt8k2w4jdil" />
            </a>
            <a href="/solutions" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1866" data-mp="1zjvp7mzdodfi">
              Solutions using it
              <ArrowRight size={16} aria-hidden="true" data-id="element-1867" data-mp="3b1epp7lkq2ad" />
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}